var _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.413 9.753c.505 0 .913-.392.913-.876 0-.485-.408-.877-.913-.877-.504 0-.913.392-.913.877 0 .484.409.876.913.876zM15.674 14l-4.72-6.422L6.5 14",
    stroke: "#222",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.793 10.885l1.147.956 1.146-1.066 1.28 1.066 1.014-.882",
    stroke: "#222",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 6,
    width: 12,
    height: 18,
    rx: 1,
    transform: "rotate(90 21.5 6)",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "M3.5 14.5h18",
    className: "stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostcard);
export default __webpack_public_path__ + "static/media/postcard.00b92e10.svg";
export { ForwardRef as ReactComponent };